import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card mb-25 border-0 rounded-0 bg-white shadow-sm" }
const _hoisted_3 = {
  class: "card-header d-flex justify-content-between align-items-center py-4 px-4",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_4 = { class: "text-white fw-bold mb-1" }
const _hoisted_5 = { class: "text-white opacity-75" }
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-30 letter-spacing" }
const _hoisted_7 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_8 = {
  key: 0,
  class: "alert alert-warning border-0 shadow-sm mb-4"
}
const _hoisted_9 = { class: "d-flex align-items-center gap-3" }
const _hoisted_10 = { class: "mb-1 fw-bold" }
const _hoisted_11 = { class: "badge bg-warning text-dark ms-2" }
const _hoisted_12 = { class: "row g-4 mb-5" }
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = { class: "mb-0 fw-bold" }
const _hoisted_15 = { class: "col-md-4" }
const _hoisted_16 = { class: "mb-0" }
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = { class: "mb-0" }
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = { class: "mb-0" }
const _hoisted_21 = { class: "badge bg-primary" }
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = { class: "mb-0" }
const _hoisted_24 = { class: "col-md-4" }
const _hoisted_25 = { class: "mb-0" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "mb-0" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "mb-0" }
const _hoisted_30 = { class: "alert alert-warning mb-4" }
const _hoisted_31 = { class: "row g-4 mb-5" }
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "mb-0 fw-bold fs-5" }
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "mb-0" }
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "mb-0 fw-bold fs-5" }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "mb-0" }
const _hoisted_40 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_41 = { class: "d-flex flex-wrap gap-2 mt-2" }
const _hoisted_42 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_43 = { class: "col-md-4" }
const _hoisted_44 = { class: "mb-0" }
const _hoisted_45 = { class: "col-md-4" }
const _hoisted_46 = { class: "mb-0 fw-bold fs-5" }
const _hoisted_47 = { class: "col-md-4" }
const _hoisted_48 = { class: "mb-0" }
const _hoisted_49 = { class: "col-md-4" }
const _hoisted_50 = { class: "mb-0" }
const _hoisted_51 = { class: "badge bg-primary" }
const _hoisted_52 = { class: "col-md-4" }
const _hoisted_53 = { class: "mb-0" }
const _hoisted_54 = { class: "col-md-4" }
const _hoisted_55 = { class: "mb-0" }
const _hoisted_56 = { class: "col-md-4" }
const _hoisted_57 = { class: "mb-0" }
const _hoisted_58 = { class: "col-md-4" }
const _hoisted_59 = { class: "mb-0" }
const _hoisted_60 = { class: "col-md-4" }
const _hoisted_61 = { class: "mb-0" }
const _hoisted_62 = { class: "col-md-6" }
const _hoisted_63 = { class: "mb-0 fw-bold fs-5" }
const _hoisted_64 = { class: "col-md-6" }
const _hoisted_65 = { class: "mb-0 fw-bold fs-5" }
const _hoisted_66 = { class: "col-md-4" }
const _hoisted_67 = { class: "mb-0" }
const _hoisted_68 = { class: "col-md-4" }
const _hoisted_69 = { class: "mb-0" }
const _hoisted_70 = { class: "col-md-4" }
const _hoisted_71 = { class: "mb-0" }
const _hoisted_72 = { class: "col-md-4" }
const _hoisted_73 = { class: "mb-0" }
const _hoisted_74 = { class: "col-md-4" }
const _hoisted_75 = { class: "mb-0" }
const _hoisted_76 = { class: "col-md-4" }
const _hoisted_77 = { class: "mb-0" }
const _hoisted_78 = { class: "col-md-4" }
const _hoisted_79 = { class: "mb-0" }
const _hoisted_80 = { class: "col-md-4" }
const _hoisted_81 = { class: "mb-0" }
const _hoisted_82 = { class: "col-md-12" }
const _hoisted_83 = { class: "mb-0" }
const _hoisted_84 = { class: "d-flex flex-wrap align-items-center gap-4 mb-5 border p-4 rounded bg-light" }
const _hoisted_85 = {
  key: 0,
  class: "d-flex align-items-center gap-2"
}
const _hoisted_86 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_87 = {
  key: 1,
  class: "d-flex align-items-center gap-2"
}
const _hoisted_88 = { class: "fw-bold" }
const _hoisted_89 = { class: "d-flex align-items-center gap-2" }
const _hoisted_90 = { class: "fw-bold text-success" }
const _hoisted_91 = { class: "d-flex align-items-center gap-2" }
const _hoisted_92 = { class: "fw-bold text-danger" }
const _hoisted_93 = {
  key: 2,
  class: "text-muted fst-italic"
}
const _hoisted_94 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_95 = { class: "bg-light p-4 rounded" }
const _hoisted_96 = { class: "mb-0" }
const _hoisted_97 = { class: "d-flex justify-content-between mt-5 pt-4 border-top" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("h3", _hoisted_4, " Détail de la règle de tarification – " + _toDisplayString(_ctx.rule.code || 'Chargement...'), 1),
          _createElementVNode("small", _hoisted_5, " Nom : " + _toDisplayString(_ctx.rule.name) + " • Créée le " + _toDisplayString(_ctx.formatDate(_ctx.rule.createdAt)), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("span", {
            class: _normalizeClass(["badge fs-5 px-4 py-2", _ctx.rule.isActive ? 'bg-success' : 'bg-secondary'])
          }, _toDisplayString(_ctx.rule.isActive ? 'Active' : 'Inactive'), 3)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("div", {
                class: "spinner-border text-primary",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
              ], -1)
            ]))]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.rule.isExemptionRule)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fas fa-percentage fa-2x text-warning" }, null, -1)),
                      _createElementVNode("div", null, [
                        _createElementVNode("h5", _hoisted_10, [
                          _cache[1] || (_cache[1] = _createTextVNode(" RÈGLE D'EXEMPTION (RÉDUCTION) ", -1)),
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.rule.exemptionRate ? _ctx.rule.exemptionRate + '%' : 'Non défini'), 1)
                        ]),
                        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mb-0" }, "Cette règle applique une réduction sur les montants calculés.", -1))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _cache[48] || (_cache[48] = _createElementVNode("div", { class: "alert alert-primary mb-4" }, [
                _createElementVNode("strong", null, "Étape 1 :"),
                _createTextVNode(" Informations de base de la règle ")
              ], -1)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Code", -1)),
                  _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.rule.code || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Nom", -1)),
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.rule.name || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Zone Tarifaire", -1)),
                  _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.rule.tariffZone?.code ? `${_ctx.rule.tariffZone.code} - ${_ctx.rule.tariffZone.name}` : '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Type d'entité", -1)),
                  _createElementVNode("p", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.getEntityTypeLabel(_ctx.rule.appliesToEntityType)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Priorité", -1)),
                  _createElementVNode("p", _hoisted_23, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.rule.priority), 1),
                    _cache[8] || (_cache[8] = _createElementVNode("small", { class: "text-muted ms-2" }, "(plus le nombre est bas, plus prioritaire)", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Statut", -1)),
                  _createElementVNode("p", _hoisted_25, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", _ctx.rule.isActive ? 'bg-success' : 'bg-secondary'])
                    }, _toDisplayString(_ctx.rule.isActive ? 'Active' : 'Inactive'), 3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Date de début", -1)),
                  _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.rule.effectiveFrom ? _ctx.formatDate(_ctx.rule.effectiveFrom) : 'Immédiate'), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Date de fin", -1)),
                  _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.rule.effectiveTo ? _ctx.formatDate(_ctx.rule.effectiveTo) : 'Sans limite'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _cache[13] || (_cache[13] = _createElementVNode("strong", null, "Étape 3 :", -1)),
                _createTextVNode(" Configuration principale de la règle (" + _toDisplayString(_ctx.getEntityTypeLabel(_ctx.rule.appliesToEntityType)) + ") ", 1)
              ]),
              _createElementVNode("div", _hoisted_31, [
                (['BESC', 'BL'].includes(_ctx.rule.appliesToEntityType))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_32, [
                        _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Montant de base", -1)),
                        _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.formatNumber(_ctx.rule.baseAmount)) + " " + _toDisplayString(_ctx.rule.amountCurrency || 'EUROS'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Devise", -1)),
                        _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.rule.amountCurrency || '-'), 1)
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.rule.appliesToEntityType === 'CONTAINER')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_36, [
                        _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Montant par conteneur", -1)),
                        _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.formatNumber(_ctx.rule.perContainerAmount)) + " " + _toDisplayString(_ctx.rule.amountCurrency || 'EUROS'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Devise", -1)),
                        _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.rule.amountCurrency || '-'), 1)
                      ]),
                      (_ctx.metadata.containerTypes?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Types de conteneur concernés", -1)),
                            _createElementVNode("div", _hoisted_41, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metadata.containerTypes, (type) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: type.id || type,
                                  class: "badge bg-info fs-6"
                                }, _toDisplayString(type.name || type.label || type.libelle || type), 1))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.metadata.requireDistantOrigin)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [...(_cache[19] || (_cache[19] = [
                            _createElementVNode("div", { class: "alert alert-info mt-3" }, [
                              _createElementVNode("i", { class: "fas fa-globe me-2" }),
                              _createElementVNode("strong", null, "Uniquement pour origines lointaines"),
                              _createTextVNode(" (Asie, Amérique, Océanie) ")
                            ], -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.rule.appliesToEntityType === 'CARGO_LINE')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("div", _hoisted_43, [
                        _cache[20] || (_cache[20] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Catégorie de produit", -1)),
                        _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.rule.categorieProduit?.name || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Montant par ligne", -1)),
                        _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.formatNumber(_ctx.rule.baseAmount)) + " " + _toDisplayString(_ctx.rule.amountCurrency || 'EUROS'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _cache[22] || (_cache[22] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Devise", -1)),
                        _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.rule.amountCurrency || '-'), 1)
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.rule.appliesToEntityType === 'GOODS')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      (_ctx.rule.packagingType)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[32] || (_cache[32] = _createElementVNode("div", { class: "col-md-12 mb-3" }, [
                              _createElementVNode("div", { class: "alert alert-info" }, [
                                _createElementVNode("i", { class: "fas fa-box me-2" }),
                                _createElementVNode("strong", null, "Marchandises avec conditionnement")
                              ])
                            ], -1)),
                            _createElementVNode("div", _hoisted_49, [
                              _cache[23] || (_cache[23] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Type de conditionnement", -1)),
                              _createElementVNode("p", _hoisted_50, [
                                _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.getPackagingTypeLabel(_ctx.rule.packagingType)), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_52, [
                              _cache[24] || (_cache[24] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Taille de la tranche", -1)),
                              _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.rule.trancheSize || '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                              _cache[25] || (_cache[25] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Unité de mesure", -1)),
                              _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.getUnitOfMeasureLabel(_ctx.rule.unitOfMeasure) || '-'), 1)
                            ]),
                            (['ROULANT_LEGER', 'ROULANT_LOURD'].includes(_ctx.rule.packagingType))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("div", _hoisted_56, [
                                    _cache[26] || (_cache[26] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Poids minimum (tonnes)", -1)),
                                    _createElementVNode("p", _hoisted_57, _toDisplayString(_ctx.rule.minWeight || '0'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_58, [
                                    _cache[27] || (_cache[27] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Poids maximum (tonnes)", -1)),
                                    _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.rule.maxWeight || 'Illimité'), 1)
                                  ])
                                ], 64))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_60, [
                              _cache[28] || (_cache[28] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Max par ECTN", -1)),
                              _createElementVNode("p", _hoisted_61, _toDisplayString(_ctx.rule.maxPerEctn || '-'), 1)
                            ]),
                            _cache[33] || (_cache[33] = _createElementVNode("div", { class: "col-md-12 mt-3" }, [
                              _createElementVNode("div", { class: "alert alert-success" }, [
                                _createElementVNode("strong", null, [
                                  _createElementVNode("i", { class: "fas fa-globe me-2" }),
                                  _createTextVNode("Tarifs par origine géographique")
                                ])
                              ])
                            ], -1)),
                            _createElementVNode("div", _hoisted_62, [
                              _cache[29] || (_cache[29] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                                _createElementVNode("i", { class: "fas fa-map-marker-alt text-primary me-2" }),
                                _createTextVNode(" Tarif Europe/Afrique (origines locales) ")
                              ], -1)),
                              _createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.metadata.tariffs?.localOrigins ? _ctx.formatNumber(_ctx.metadata.tariffs.localOrigins) + ' ' + (_ctx.rule.amountCurrency || 'EUR') : '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_64, [
                              _cache[30] || (_cache[30] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                                _createElementVNode("i", { class: "fas fa-globe-americas text-warning me-2" }),
                                _createTextVNode(" Tarif Asie/Amérique/Océanie (origines lointaines) ")
                              ], -1)),
                              _createElementVNode("p", _hoisted_65, _toDisplayString(_ctx.metadata.tariffs?.distantOrigins ? _ctx.formatNumber(_ctx.metadata.tariffs.distantOrigins) + ' ' + (_ctx.rule.amountCurrency || 'EUR') : '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_66, [
                              _cache[31] || (_cache[31] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Devise", -1)),
                              _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.rule.amountCurrency || '-'), 1)
                            ])
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_68, [
                              _cache[34] || (_cache[34] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Catégorie de produit", -1)),
                              _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.rule.categorieProduit?.name || '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_70, [
                              _cache[35] || (_cache[35] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Montant fixe par marchandise", -1)),
                              _createElementVNode("p", _hoisted_71, _toDisplayString(_ctx.rule.baseAmount ? _ctx.formatNumber(_ctx.rule.baseAmount) + ' ' + (_ctx.rule.amountCurrency || 'EUROS') : '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_72, [
                              _cache[36] || (_cache[36] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "OU Taux % sur la valeur", -1)),
                              _createElementVNode("p", _hoisted_73, _toDisplayString(_ctx.rule.percentageRate ? _ctx.rule.percentageRate + '%' : '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_74, [
                              _cache[37] || (_cache[37] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Devise", -1)),
                              _createElementVNode("p", _hoisted_75, _toDisplayString(_ctx.rule.amountCurrency || '-'), 1)
                            ])
                          ], 64))
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.rule.appliesToEntityType === 'VALUE_BRACKET')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createElementVNode("div", _hoisted_76, [
                        _cache[38] || (_cache[38] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Valeur minimum (EUROS)", -1)),
                        _createElementVNode("p", _hoisted_77, _toDisplayString(_ctx.formatNumber(_ctx.rule.minDeclaredValue) || '0'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_78, [
                        _cache[39] || (_cache[39] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Valeur maximum (EUROS)", -1)),
                        _createElementVNode("p", _hoisted_79, _toDisplayString(_ctx.rule.maxDeclaredValue ? _ctx.formatNumber(_ctx.rule.maxDeclaredValue) : 'Illimité'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_80, [
                        _cache[40] || (_cache[40] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Taux appliqué (%)", -1)),
                        _createElementVNode("p", _hoisted_81, _toDisplayString(_ctx.rule.percentageRate ? _ctx.rule.percentageRate + '%' : '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_82, [
                        _cache[41] || (_cache[41] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "OU Montant fixe (EUROS)", -1)),
                        _createElementVNode("p", _hoisted_83, _toDisplayString(_ctx.rule.baseAmount ? _ctx.formatNumber(_ctx.rule.baseAmount) : '-'), 1)
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _cache[49] || (_cache[49] = _createElementVNode("div", { class: "alert alert-secondary mb-4" }, [
                _createElementVNode("strong", null, "Étape 4 :"),
                _createTextVNode(" Options avancées (facultatif) ")
              ], -1)),
              _createElementVNode("div", _hoisted_84, [
                (_ctx.metadata.loadingPortRegion?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                      _cache[42] || (_cache[42] = _createElementVNode("label", { class: "text-black fw-semibold mb-0 text-nowrap" }, [
                        _createElementVNode("i", { class: "fas fa-globe me-2" }),
                        _createTextVNode(" Continents du port de chargement : ")
                      ], -1)),
                      _createElementVNode("div", _hoisted_86, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metadata.loadingPortRegion, (region) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: region,
                            class: "badge bg-secondary"
                          }, _toDisplayString(_ctx.getContinentLabel(region)), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.rule.regimedouanier)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                      _cache[43] || (_cache[43] = _createElementVNode("label", { class: "text-black fw-semibold mb-0 text-nowrap" }, "Régime douanier :", -1)),
                      _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.rule.regimedouanier.name || '-'), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_89, [
                  _cache[44] || (_cache[44] = _createElementVNode("label", { class: "text-black fw-semibold mb-0 text-nowrap" }, "Montant minimum facturé :", -1)),
                  _createElementVNode("span", _hoisted_90, _toDisplayString(_ctx.rule.minFeeAmount ? _ctx.formatNumber(_ctx.rule.minFeeAmount) + ' EUROS' : 'Aucun'), 1)
                ]),
                _createElementVNode("div", _hoisted_91, [
                  _cache[45] || (_cache[45] = _createElementVNode("label", { class: "text-black fw-semibold mb-0 text-nowrap" }, "Montant maximum facturé :", -1)),
                  _createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.rule.maxFeeAmount ? _ctx.formatNumber(_ctx.rule.maxFeeAmount) + ' EUROS' : 'Aucun'), 1)
                ]),
                (!_ctx.metadata.loadingPortRegion?.length && !_ctx.rule.regimedouanier && !_ctx.rule.minFeeAmount && !_ctx.rule.maxFeeAmount)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_93, " Aucune option avancée définie "))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.rule.description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                    _cache[46] || (_cache[46] = _createElementVNode("h5", { class: "text-primary fw-bold mb-3" }, "Description", -1)),
                    _createElementVNode("div", _hoisted_95, [
                      _createElementVNode("p", _hoisted_96, _toDisplayString(_ctx.rule.description), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_97, [
                _createVNode(_component_router_link, {
                  to: "/listeBescPricingRule",
                  class: "btn btn-secondary px-5 py-2"
                }, {
                  default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                    _createTextVNode(" Retour à la liste ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ], 64))
      ])
    ])
  ]))
}